const saveOfferRequest = ({ http, offerId }) => http.put('/saved-offers/me', { offerId });

const removeOfferRequest = ({ http, offerId }) => {
  const params = {
    offerId
  };

  return http.delete(`/saved-offers/me/${offerId}`, { params });
};

export {
  saveOfferRequest,
  removeOfferRequest
};
